import { useQuery } from '@apollo/client'
import BrokenImageIcon from '@mui/icons-material/BrokenImage'
import CircularProgress from '@mui/material/CircularProgress'

import { queries } from '../../graphql'
import { CategoryChip } from '../../pages/charity-portal/charity-category-icons'

export function CharityLogo({ charityId, categoryCode, logo: savedLogo, temporarySrc, link, sx, ...props }) {
  const shouldFetchCategories =
    charityId && !temporarySrc && (!savedLogo || (!savedLogo.logo && !savedLogo.logoPath)) && !link

  const {
    data: categoriesData,
    loading: categoriesLoading,
    error,
  } = useQuery(queries.charities.getMyCharityCategories, {
    variables: { charityId },
    skip: !shouldFetchCategories,
  })

  let logoImage

  if (
    temporarySrc &&
    (temporarySrc.startsWith('data:image/') || temporarySrc.startsWith('blob:')) &&
    !temporarySrc.includes('base64,null') &&
    !temporarySrc.includes('base64,undefined')
  ) {
    logoImage = (
      <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={temporarySrc} alt="temporary logo" />
    )
  } else if (savedLogo?.logo) {
    logoImage = (
      <img
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        src={`data:image/jpeg;base64,${savedLogo.logo}`}
        alt="charity logo"
      />
    )
  } else if (savedLogo?.logoPath) {
    logoImage = (
      <img
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        src={savedLogo.logoPath}
        alt="charity logo"
      />
    )
  } else if (link) {
    logoImage = <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={link} alt="linked logo" />
  } else if (categoriesLoading) {
    logoImage = <CircularProgress size={24} sx={{ color: 'grey.400' }} />
  } else if (categoriesData?.getMyCharityCategories?.[0]?.category) {
    logoImage = (
      <CategoryChip
        name={categoriesData.getMyCharityCategories[0].category.name}
        iconName={categoriesData.getMyCharityCategories[0].category.iconName}
        text={false}
      />
    )
  } else if (error) {
    logoImage = <BrokenImageIcon sx={{ width: '100%', height: '100%', color: 'error.light' }} />
  } else {
    logoImage = <BrokenImageIcon sx={{ width: '100%', height: '100%', color: 'grey.400' }} />
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
      }}
    >
      {logoImage}
    </div>
  )
}
